var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamsAssessments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_2758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.25H6.25L6.55156 13.873C6.97734 13.3408 7.05481 12.6096 6.75 12H9.25C8.94519 12.6096 9.02266 13.3408 9.44844 13.873L9.75 14.25Z",
    fill: "#5C98E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 12.25H1.375C1.02981 12.25 0.75 11.9702 0.75 11.625V2.875C0.75 2.52981 1.02981 2.25 1.375 2.25H14.625C14.9702 2.25 15.25 2.52981 15.25 2.875V11.625C15.25 11.9702 14.9702 12.25 14.625 12.25Z",
    fill: "#5C98E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 12.25H1.375C1.02981 12.25 0.75 11.9702 0.75 11.625V10.75H15.25V11.625C15.25 11.9702 14.9702 12.25 14.625 12.25Z",
    fill: "#3E6599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7353 13.75H5.26472C5.11197 13.75 4.98159 13.8604 4.95647 14.0111L4.75 15.25H11.25L11.0435 14.0111C11.0184 13.8604 10.888 13.75 10.7353 13.75Z",
    fill: "#3E6599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.75H6.75C6.61194 11.75 6.5 11.6381 6.5 11.5C6.5 11.3619 6.61194 11.25 6.75 11.25H9.25C9.38806 11.25 9.5 11.3619 9.5 11.5C9.5 11.6381 9.38806 11.75 9.25 11.75Z",
    fill: "#213652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 11.75H10.25C10.1119 11.75 10 11.6381 10 11.5C10 11.3619 10.1119 11.25 10.25 11.25H11.75C11.8881 11.25 12 11.3619 12 11.5C12 11.6381 11.8881 11.75 11.75 11.75Z",
    fill: "#213652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.75H4.25C4.11194 11.75 4 11.6381 4 11.5C4 11.3619 4.11194 11.25 4.25 11.25H5.75C5.88806 11.25 6 11.3619 6 11.5C6 11.6381 5.88806 11.75 5.75 11.75Z",
    fill: "#213652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2506 11.75C14.1126 11.75 14.0005 11.6381 14.0005 11.5C14.0005 11.3619 14.1123 11.25 14.2503 11.25H14.2506C14.3887 11.25 14.5006 11.3619 14.5006 11.5C14.5006 11.6381 14.3887 11.75 14.2506 11.75Z",
    fill: "#E6AC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 11.75C13.3626 11.75 13.2505 11.6381 13.2505 11.5C13.2505 11.3619 13.3623 11.25 13.5003 11.25H13.5006C13.6387 11.25 13.7506 11.3619 13.7506 11.5C13.7506 11.6381 13.6387 11.75 13.5006 11.75Z",
    fill: "#E6AC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 11.75C12.6126 11.75 12.5005 11.6381 12.5005 11.5C12.5005 11.3619 12.6123 11.25 12.7503 11.25H12.7506C12.8887 11.25 13.0006 11.3619 13.0006 11.5C13.0006 11.6381 12.8887 11.75 12.7506 11.75Z",
    fill: "#E6AC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0.75H13.25V10.75H2.75V0.75Z",
    fill: "#E6AC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4H3.75C3.61194 4 3.5 3.88806 3.5 3.75V1.75C3.5 1.61194 3.61194 1.5 3.75 1.5H5.25C5.38806 1.5 5.5 1.61194 5.5 1.75C5.5 1.88806 5.38806 2 5.25 2H4V3.5H5.25C5.38806 3.5 5.5 3.61194 5.5 3.75C5.5 3.88806 5.38806 4 5.25 4Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3H3.75C3.61194 3 3.5 2.88806 3.5 2.75C3.5 2.61194 3.61194 2.5 3.75 2.5H5.25C5.38806 2.5 5.5 2.61194 5.5 2.75C5.5 2.88806 5.38806 3 5.25 3Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75019 4.00001C7.67419 4.00001 7.59913 3.96551 7.55 3.90001L6.05 1.90001C5.96719 1.78957 5.98953 1.63286 6.10003 1.55001C6.21038 1.4672 6.36716 1.48951 6.45003 1.60004L7.95003 3.60004C8.03285 3.71048 8.0105 3.8672 7.9 3.95004C7.85503 3.98373 7.80241 4.00001 7.75019 4.00001Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24981 4.00001C6.19759 4.00001 6.14499 3.98373 6.09999 3.95001C5.98953 3.86717 5.96715 3.71045 6.04996 3.60001L7.54996 1.60001C7.63287 1.48954 7.78953 1.4672 7.89996 1.54998C8.01043 1.63282 8.03281 1.78954 7.94999 1.89998L6.44999 3.89998C6.40087 3.96551 6.32581 4.00001 6.24981 4.00001Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.00006C9.89881 4.00006 9.80356 3.93816 9.76594 3.83778L9.25 2.462L8.73406 3.83775C8.68559 3.96709 8.54138 4.03262 8.41222 3.98406C8.28291 3.93559 8.21744 3.7915 8.26591 3.66222L9.01591 1.66222C9.05253 1.56463 9.14578 1.5 9.25 1.5C9.35422 1.5 9.44747 1.56463 9.48406 1.66222L10.2341 3.66222C10.2826 3.7915 10.2171 3.93559 10.0878 3.98406C10.0589 3.99494 10.0292 4.00006 10 4.00006Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.5H8.75C8.61194 3.5 8.5 3.38806 8.5 3.25C8.5 3.11194 8.61194 3 8.75 3H9.75C9.88806 3 10 3.11194 10 3.25C10 3.38806 9.88806 3.5 9.75 3.5Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.00005C12.1119 4.00005 12 3.88811 12 3.75005V2.50005L11.7 2.90005C11.6528 2.96302 11.5787 3.00005 11.5 3.00005C11.4213 3.00005 11.3472 2.96299 11.3 2.90005L11 2.50005V3.75005C11 3.88811 10.8881 4.00005 10.75 4.00005C10.6119 4.00005 10.5 3.88811 10.5 3.75005V1.75005C10.5 1.64246 10.5688 1.54689 10.6709 1.51286C10.7731 1.47899 10.8855 1.51396 10.95 1.60005L11.5 2.33339L12.05 1.60005C12.1146 1.51393 12.2269 1.4788 12.3291 1.51286C12.4312 1.54689 12.5 1.64243 12.5 1.75005V3.75005C12.5 3.88811 12.3881 4.00005 12.25 4.00005Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5H6C5.86194 5 5.75 4.88806 5.75 4.75C5.75 4.61194 5.86194 4.5 6 4.5H9C9.13806 4.5 9.25 4.61194 9.25 4.75C9.25 4.88806 9.13806 5 9 5Z",
    fill: "#E65C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.75H3.75C3.61194 5.75 3.5 5.63806 3.5 5.5C3.5 5.36194 3.61194 5.25 3.75 5.25H9C9.13806 5.25 9.25 5.36194 9.25 5.5C9.25 5.63806 9.13806 5.75 9 5.75Z",
    fill: "#E65C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.5H3.75C3.61194 6.5 3.5 6.38806 3.5 6.25C3.5 6.11194 3.61194 6 3.75 6H9C9.13806 6 9.25 6.11194 9.25 6.25C9.25 6.38806 9.13806 6.5 9 6.5Z",
    fill: "#E65C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.25H12.25V9.75H5.25V7.25Z",
    fill: "#5C98E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.25H6C5.86194 8.25 5.75 8.13806 5.75 8C5.75 7.86194 5.86194 7.75 6 7.75H8.75C8.88806 7.75 9 7.86194 9 8C9 8.13806 8.88806 8.25 8.75 8.25Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H6C5.86194 9 5.75 8.88806 5.75 8.75C5.75 8.61194 5.86194 8.5 6 8.5H9C9.13806 8.5 9.25 8.61194 9.25 8.75C9.25 8.88806 9.13806 9 9 9Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.318 7.99265L9.72704 8.52299L10.2574 6.93199L13.9697 3.21968C14.2626 2.92677 14.7375 2.92677 15.0303 3.21968C15.3233 3.51259 15.3233 3.98746 15.0303 4.28034L11.318 7.99265Z",
    fill: "#E65C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7877 7.71222C10.7237 7.71222 10.6597 7.68781 10.6109 7.639C10.5133 7.54134 10.5133 7.38309 10.6109 7.28544L13.7929 4.10347C13.8905 4.00588 14.0488 4.00588 14.1464 4.10347C14.2441 4.20112 14.2441 4.35938 14.1464 4.45703L10.9645 7.639C10.9157 7.68781 10.8517 7.71222 10.7877 7.71222Z",
    fill: "#5D2526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0303 3.21968C14.7374 2.92677 14.2626 2.92677 13.9697 3.21968L13.4393 3.75002L14.5 4.81068L15.0303 4.28034C15.3232 3.98746 15.3232 3.51259 15.0303 3.21968Z",
    fill: "#243B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2573 6.93188L11.318 7.99257L9.72704 8.52288L10.2573 6.93188Z",
    fill: "#243B59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_2758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamsAssessments);
export default __webpack_public_path__ + "static/media/ExamsAssessments.cd30245e4f6fc7ee62caa8038b90411c.svg";
export { ForwardRef as ReactComponent };